<template>
  <div>
    <vmodal 
      name="addEditLocationGroupModal"
      class="addEditLocationGroupModal"
      :minWidth="1300"
      :minHeight="900"
      :adaptive="true"
    >
      <location-groups-form
        :editData="editData"
        @close-modal="hideAddLocationGroupModal($event)"
        @on-submit="handleNewLocationGroup($event)"
      ></location-groups-form>
    </vmodal>
  </div>
</template>
<script>
  import LocationGroupsForm from './LocationGroupsForm.vue'

  export default {
    components: {
      LocationGroupsForm
    },
    data () {
      return {}
    },
    props: {
      editData: {
        required: false,
        type: Object
      },
      openModal: {
        required: true,
        type: Boolean
      }
    },
    watch: {
      openModal () {
        this.openAddLocationGroupModal()
      }
    },
    methods: {
      handleNewLocationGroup (newGroup) {
        if (!this.editData) {
          this.$emit('new-group', newGroup)
        } else if (
          this.editData &&
          newGroup &&
          this.editData.parent_id !== newGroup.parent_id
        ) {
          if (this.editData.location_ids !== newGroup.location_ids) {
            newGroup.location_ids = null
          }
          this.$emit('new-group', newGroup)
          this.$emit('delete-group', this.editData)
        }
        if (this.editData && this.editData.image !== newGroup.image) {
          this.$emit('edit-group', newGroup)
        }
        this.hideAddLocationGroupModal()
      },
      openAddLocationGroupModal () {
        this.$modal.show('addEditLocationGroupModal')
      },
      hideAddLocationGroupModal (deletedGroup = null) {
        if (deletedGroup) {
          this.$emit('delete-group', deletedGroup)
        }
        this.$modal.hide('addEditLocationGroupModal')
      }
    }
  }
</script>
<style>
  .upload-demo input[type="file"]{ display: none; }
  span.el-select__tags-text {
    color: #fff;
  }
  .el-select {
    width: 100%;
  }
  .selectMethod {
    width: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/LocationGroups/AddEditModal.vue